__turbopack_context__.v({
  "Description": "Description-module__dKJMtq__Description",
  "SimilarProductsRow": "Description-module__dKJMtq__SimilarProductsRow",
  "active": "Description-module__dKJMtq__active",
  "body": "Description-module__dKJMtq__body",
  "button": "Description-module__dKJMtq__button",
  "changer": "Description-module__dKJMtq__changer",
  "container": "Description-module__dKJMtq__container",
  "icon": "Description-module__dKJMtq__icon",
  "left": "Description-module__dKJMtq__left",
  "products": "Description-module__dKJMtq__products",
  "right": "Description-module__dKJMtq__right",
  "specification": "Description-module__dKJMtq__specification",
  "tab": "Description-module__dKJMtq__tab",
  "tabs": "Description-module__dKJMtq__tabs",
  "title": "Description-module__dKJMtq__title",
});
